import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./style.scss";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from "./component/header/Header";
import Contact from "./component/Contact/Contact";
import Home from "./component/Home/Home";
import Nannycategories from "./component/Nanny-categories/Nannycategories";
import Services from "./component/Services/Services";
import About from "./component/about/About";
import Login from "./component/auth/login/Login";
import Blogs from "./component/blogs/Blogs";
import Events from "./component/events/Events";
import Footer from "./component/footer/Footer";
import Tutorings from "./component/tutorings/Tutorings";
import MyOrdersComponent from "./component/my-orders/My_Orders_Component";
import Profile from "./component/profile/Profile";
import Nanylisting from "./component/nany-listing/Nanylisting";
import CustomModal from "./component/CustomModal/CustomModal";
import Redeempromotion from "./component/Redeempromotion/Redeempromotion";
import Bookdetails from "./component/Redeempromotion/Bookdetails";
import Payment from "./component/Redeempromotion/Payment";
import Forgotpassword from "./component/auth/Forgotpassword/Forgotpassword";
import Signupfamily from "./component/auth/RegisterAsFamily/Signupfamily";
import Otp from "./component/auth/Otp";
import Signupnanny from "./component/auth/Signupnanny";
import Card from "./component/Nanny-categories/Card";
import Availability from "./component/Availability/Availability";
import Profilenanny from "./component/profile/Profilenanny";
import Nannyprofile from "./component/profile/Nannyprofile";
import Nannybooking from "./component/Nannybooking/Nannybooking";
import HeaderNanny from "./component/header/HeaderNanny";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import io from "socket.io-client";
import Dayschange from "./component/Availability/Dayschange";
import Googlemap from "./component/map/Googlemap";
import NeditProfile from "./component/profile/NeditProfile";
import MyAddress from "./component/MyAddress/MyAddress";
import { GoogleOAuthProvider } from "@react-oauth/google";
import StipePayment from "./component/stripe/CheckoutForm";
import PrivacyPolicy from "./component/PrivacyPolicy/PrivacyPolicy";
import Download from "./component/download/Download";
import ServicesDetail from "./component/Services details/ServicesDetail";
import PhoneOtp from "./component/auth/PhoneOtp/PhoneOtp";
import BookingInput from "./component/Nanny-categories/bookingInput";
import PaymentSuccess from "./component/stripe/PaymentSuccess";
import StripeConnectFailed from "./component/stripe/StripeConnectFailed";
import StripeConnectSuccess from "./component/stripe/StripeConnectSuccess";
import TermCondition from "./component/TermCondition.js/TermCondition";
import PaypalPaymentSuccess from "./component/Paypal/PaymentSuccess";
import PaymentOptions from "./component/PaymentOption/PaymentOptions";
import PaypalConnectSuccess from "./component/Paypal/PaypalConnectSuccess";
import PaypalConnectFailed from "./component/Paypal/PaypalConnectFailed";

function App() {
  const [type, setType] = useState("");
  const user = useSelector((state) => state.rootReducer.login.data);
  const localType = localStorage.getItem("type");
  useEffect(() => {
    if (user != null && user.status === 1) {
      setType(user.data.type);
    }
  }, [user]);

  return (
    <>
      <GoogleOAuthProvider clientId="your-client-id">
        <BrowserRouter>
          <ToastContainer position="bottom-right" autoClose={3000} />
          {type == 2 || localType == 2 ? <Header /> : <HeaderNanny />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog" element={<Blogs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signupfamily" element={<Signupfamily />} />
            <Route path="/forgot-password" element={<Forgotpassword />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/phone_otp" element={<PhoneOtp />} />
            <Route path="/signupnanny" element={<Signupnanny />} />
            <Route path="/events" element={<Events />} />
            <Route path="/nannycategories" element={<Nannycategories />} />
            <Route path="/add-booking-details" element={<BookingInput />} />
            <Route path="/tutorings" element={<Tutorings />} />
            <Route path="/my_orders_component" element={<MyOrdersComponent />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/nanyList" element={<Nanylisting />} />
            <Route path="/customModal" element={<CustomModal />} />
            <Route path="/redeempromotion" element={<Redeempromotion />} />
            <Route path="/bookdetails" element={<Bookdetails />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/card" element={<Card />} />
            <Route path="/availability" element={<Availability />} />
            <Route path="/profilenanny" element={<Profilenanny />} />
            <Route path="/Nannybooking" element={<Nannybooking />} />
            <Route path="/dayschange" element={<Dayschange />} />
            <Route path="/googlemap" element={<Googlemap />} />
            <Route path="/neditProfile" element={<NeditProfile />} />
            <Route path="/my_address" element={<MyAddress />} />


            <Route path="/privacy_policy" element={<PrivacyPolicy />} />
            <Route path="/term_condition" element={<TermCondition />} />
            <Route path="/download" element={<Download />} />
            <Route path="/services_details/:id" element={<ServicesDetail />} />

            <Route path="/personal-words-from-our-ceo-about-racism" element={<Home />} />
            <Route path="/the-newest-family-travel-trend-caravaning-in-spain" element={<Home />} />
            <Route path="/tutoring" element={<Home />} />
            <Route path="/shop" element={<Services />} />
            <Route path="/self-improvement-2" element={<Home />} />
            <Route path="/couples-guidance-2" element={<Home />} />
            <Route path="/couples-guidance" element={<Home />} />
            <Route path="/11-coaching-2" element={<Home />} />
            <Route path="/11-coaching" element={<Home />} />


            <Route path="/self-improvement" element={<Home />} />
            <Route path="/discovery-session-2" element={<Home />} />
            <Route path="/discovery-session" element={<Home />} />

            <Route path="/parenting" element={<Home />} />
            <Route path="/uncategorized" element={<Home />} />
            <Route path="/product-category/coaching/" element={<Home />} />

            <Route path="/payment-options" element={<PaymentOptions />} />

            <Route path="/stripe-connect-success" element={<StripeConnectSuccess />} />
            <Route path="/stripe-connect-failed" element={<StripeConnectFailed />} />
            <Route path="/StipePayment" element={<StipePayment />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />

            <Route path="/paypal-connect-success" element={<PaypalConnectSuccess />} />
            <Route path="/paypal-connect-failed" element={<PaypalConnectFailed />} />
            <Route path="/paypal-payment-success" element={<PaypalPaymentSuccess />} />

          </Routes>
          <Footer />
        </BrowserRouter>
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
